<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{'Turbo.Service.CreateServiceRequestDialog.lblContactPersonForRequestExplanation' | translate : 'Contact person'}}">

    <div>{{ 'Turbo.Service.CreateServiceRequestDialog.ContactPersonForRequestExplanation' | translate : 'Please assign a contact person from your rental location' }}</div>
    <div class="container">
      <div class="row">
        <div class="col-6">
          <mat-form-field>
            <input #txtcontactFirstName="ngModel" required matInput placeholder="{{ 'turbo.core.RentalDialog.txtFirstname' | translate : 'Firstname' }}" [(ngModel)]="data.contactFirstName">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field>
            <input #txtcontactLastName="ngModel" required matInput placeholder="{{ 'turbo.core.RentalDialog.txtLastname' | translate : 'Lastname' }}" [(ngModel)]="data.contactLastName">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field>
            <input #txtcontactEmail="ngModel" required matInput placeholder="{{ 'turbo.core.RentalDialog.txtEmail' | translate : 'Email' }}" [(ngModel)]="data.contactEmail">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <mat-form-field>
            <input #txtcontactPhone="ngModel" required matInput placeholder="{{ 'turbo.core.RentalDialog.Mobile' | translate : 'Mobile phone  ' }}" [(ngModel)]="data.contactPhone">
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="loader" *ngIf="loading">
      <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
      <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading"></mat-progress-bar>
    </div>
  </t4-container>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()" [disabled]="loading || (!data.contactFirstName || data.contactFirstName.length == 0) || (!data.contactLastName || data.contactLastName.length == 0) || (!data.contactEmail || data.contactEmail.length == 0) || (!data.contactPhone || data.contactPhone.length == 0)">
      {{'Turbo.OneWayAdmin.ServiceDialog.ContactInfoDialog.cmdSave' | translate : 'Save' }}
    </button>
  </div>
</mat-dialog-actions>
